



import React, { useState } from 'react'

import { formatBytes, getErrorMessage, getFileExtension } from 'utils'

import { useSnackbar } from 'contexts'
import { useProductsMutations } from 'hooks/api'

import { useTheme, Stack, Typography } from '@mui/material'

import { Button } from '@repo/ui'
import { Modal } from '@repo/ui'
import { FileUploadField } from 'components'


interface ImportCompanyUsersModalProps {
  open: boolean
  onClose: () => void
  refetch: () => void
}

export const ImportCompanyUsersModal = (props: ImportCompanyUsersModalProps) => {
  const { open, onClose = () => {}, refetch } = props
  const theme = useTheme()

  const [files, setFiles] = useState<any[]>([])

  const { open: notification } = useSnackbar()

  const [{ uploadProducts }, { isLoading }] = useProductsMutations({
    onSuccess: () => {

      handleClose()
      refetch()
    },
    onError: error => {
      const message = getErrorMessage(error)
      notification({
        type: 'error',
        title: message,
      })
    },
  })

  const handleImport = () => {
    if (files.length === 0) {
      notification({
        type: 'error',
        title: 'Please attach a file to import',
      })

      return
    }

    uploadProducts({
      products: files[0].file,
    })
  }

  const handleClose = () => {
    onClose()
    setFiles([])
  }

  const isFileUploadFielded = files.length > 0

  return (
    <Modal
      title="Import users"
      open={open}
      onClose={onClose}
      actions={
        <>
          <Button
            variant="secondary"
            onClick={() => handleClose()}
          >
            Cancel
          </Button>

          <Button
            onClick={() => handleImport()}
            disabled={!isFileUploadFielded}
          >
            Add
          </Button>
        </>
      }
    >
      <Stack spacing={4}>
        <FileUploadField
          acceptFiles={{ 'text/csv': ['.csv'], 'excel': ['.xlsx']  }}
          description="Accepts: CSV, XLSX, JSON"
          onFilesChange={setFiles}
        />
      </Stack>
    </Modal>
  )
}
